/**
Author - Venkatesh Pullaganti 😃
Git - https://github.com/venkatesh1146
**/

//NOTE: This is common theme and styles for both Partner and Client

const baseUnit = 14; // Desktop base unit (matches root font-size: 14px)

// Convert px to rem based on desktop base unit (14px)
const pxToRem = (px) => `${px / baseUnit}rem`;

export const baseTheme = {
  baseUnit: `${baseUnit}px`,
  pxToRem,

  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    pill: '999px',
    circle: '50%',
  },

  // Spacing scale
  spacing: {
    xs: pxToRem(4), // 0.286rem
    sm: pxToRem(8), // 0.571rem
    md: pxToRem(16), // 1.143rem
    lg: pxToRem(24), // 1.714rem
    xl: pxToRem(32), // 2.286rem
    xxl: pxToRem(48), // 3.429rem
  },

  // Breakpoints
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },

  // Media queries for easy use
  mediaQueries: {
    mobile: `@media (max-width: 767px)`,
    tablet: `@media (min-width: 768px) and (max-width: 991px)`,
    desktop: `@media (min-width: 992px)`,
    minTablet: `@media (min-width: 768px)`,
    minDesktop: `@media (min-width: 992px)`,
  },

  // Transitions
  transitions: {
    fast: '150ms ease-in-out',
    medium: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },

  // Shadows
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    md: '0 3px 6px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.12)',
    lg: '0 10px 20px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.10)',
  },

  colors: {
    border: {
      default: '#E3E3E3',
    },
  },
};
